<template>
  <v-col
    cols="12"
    class="header px-0 pb-1 pt-4"
    :style="headerStyle"
  >
    <EmailForm />
    <v-container class="py-0 pb-0 pt-2">
      <v-row v-if="!$store.state.showArticleOnly">
        <v-col cols="12">
          <div style="float: left; width: 200px">
            <div
              class="logo"
              style="padding-left: 25px; height: 105px"
            >
              <a
                style=""
                @click="goHomeAndClearSearch"
                ><img
                  style="width: 130px"
                  src="../../../../public/img/costa-sol-rent-logo.png"
                  alt="Costasolrent.com"
              /></a>
            </div>
          </div>
          <div
            style="
              float: left;
              width: calc(100% - 400px);
              padding-top: 25px;
              padding-left: 20px;
              pading-right: 40px;
            "
          >
            <div class="slogan">
              {{ $t('siteSlogan') }}
            </div>
          </div>
          <div style="float: right; padding-top: 80px; margin-right: -11px;">
            <Flags :use-menu="true" className="flags" />
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script>
import Flags from './Flags'
import EmailForm from '../../Forms/_EmailForm'
import sharedMethods from '../../../methods/sharedMethods'
import { createHelpers } from 'vuex-map-fields'
import state from '../../../store/state.js'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField',
})

export default {
  name: 'PageHeaderDesktop',

  components: {
    EmailForm,
    Flags,
  },

  computed: {
    ...mapFields(Object.keys(state)),

    headerStyle() {
      return {
        height: this.$vuetify.breakpoint.mdAndUp ? '' : '115px', // 110px
      }
    },
  },

  methods: {
    ...sharedMethods,
  },
}
</script>
